import React, { useCallback } from "react";

import { type NavAction, type SectionKey, SectionTitles } from ".";
import { faChevronRight } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ButtonLink } from "~/ui/legacyFellowIndex";

import styles from "./Breadcrumbs.module.css";

interface BreadcrumbsProps {
	pageStack: SectionKey[];
	navigate: React.Dispatch<NavAction>;
}

export function Breadcrumbs({ pageStack, navigate }: BreadcrumbsProps) {
	const pageTitle = SectionTitles[pageStack[pageStack.length - 1]];
	const backPageTitle = SectionTitles[pageStack[pageStack.length - 2]];

	const goBack = useCallback(() => navigate({ type: "back" }), [navigate]);
	const goWayBack = useCallback(() => navigate({ type: "to", payload: pageStack.slice(0, -2) }), [navigate, pageStack]);

	if (pageStack.length < 2) return <></>;

	return (
		<header className={styles.header}>
			{pageStack.length > 2 && (
				<>
					<ButtonLink onClick={goWayBack} className={styles.link}>
						…
					</ButtonLink>
					<FontAwesomeIcon icon={faChevronRight} className={styles.icon} />
				</>
			)}
			<ButtonLink onClick={goBack} className={styles.link}>
				{backPageTitle}
			</ButtonLink>
			<FontAwesomeIcon icon={faChevronRight} className={styles.icon} />
			<p className={styles.title}>{pageTitle}</p>
		</header>
	);
}
